import { render, staticRenderFns } from "./prescriptionInfo.vue?vue&type=template&id=7786ae02&scoped=true"
import script from "./prescriptionInfo.vue?vue&type=script&lang=js"
export * from "./prescriptionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7786ae02",
  null
  
)

export default component.exports